<template>
    <el-dialog
      :title="receiveTitle"
      :visible.sync="receiveDialogFormVisible"
      :width="diaWidth?diaWidth:'666px'"
      :top="exTop"
      :close-on-click-modal=false
      :append-to-body=true
      class="dislogCon">
      <div class="formCon">
      <slot></slot>
    </div>
    </el-dialog>
</template>
<script>
export default {
    props:{
        title:{
            type:String,
            default:''
        },
      exTop: {
          type: String,
          default: "30vh"
        },
        dialogFormVisible:{
           type:Boolean,
           default:false
        },
        diaWidth:{
          type:String,
          dafault:'574px'
        },
    },
    data(){
        return {
            receiveTitle:this.title,
            receiveDialogFormVisible:this.dialogFormVisible
        }
    },
    created(){
    },
    methods:{
    }
}
</script>
<style>

.dislogCon .el-dialog{
  padding: 9px 20px 20px 20px;
  border-radius: 5px
}
.dislogCon .el-dialog .el-dialog__header{
  padding: 0;
  border-bottom: 1px solid #AAAAAA;
  height: 36px;
  line-height: 36px;
}
.dislogCon .el-dialog  .el-dialog__title{
  font-size: 14px;
  color: #424242;
}
.dislogCon .el-dialog  .el-dialog__body{
  padding: 0
}
.dislogCon .formCon{
  padding: 20px 0 0 0;
  box-sizing: border-box
}
.dislogCon .formCon  .el-input{
  /* width: 369px; */
}
.dislogCon .formCon input{
  height: 40px;
  /* width: 369px; */
  background: #F2F2F2;
  color: #424242
}
.dislogCon .formCon .el-form-item__label{
      padding: 0;
      margin-right: 22px;
      text-align: left;
        color: #424242
}
.dislogCon .formCon .el-textarea__inner{
  /* width: 479px; */
  background: #F2F2F2;
  height: 94px;
  resize: none;
  border-radius: 0
}
.dislogCon .formCon .el-upload{
  width: 90px;
  height: 90px;
   background: #F2F2F2;
   border: none;
       display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.dislogCon .formCon .el-upload .upText{
  font-size: 14px;
  color: #424242;
  line-height: normal;
}
.dislogCon .formCon .uploadImg{
  display: flex
}
.dislogCon .formCon .uploadImg .el-upload-list{
    width: 90px;
  height: 90px;
  margin-right: 20px;
  position: absolute
}
.dislogCon .formCon .formBtn{
    width: 100px;
    height: 40px;
    color: #ffffff;
    border: none;
    font-size: 18px
}
.dislogCon .formCon .formBtn:nth-last-child(1){
    background: #CCCCCC
}
.dislogCon .formCon .dialog-footer{
    text-align: center
}
.dislogCon .formCon .formBtn:nth-last-child(2){
    background: #FF9E00
}
.dislogCon .formCon .uploadImg .el-upload-list__item-actions,
.dislogCon .formCon .uploadImg li{
  width: 90px;
  height: 90px;
  z-index: 3;
}
/* 论坛 */
.bbsdialog .formCon .el-textarea__inner{
  /* width: 479px; */
  background: #F2F2F2;
  height: 94px;
  resize: none;
  border-radius: 0;
}
.bbsdialog  .el-form-item__content{
    /* margin-left: 0 !important */
}
.bbsdialog .formCon .el-form-item__label{
    /* width: 64px !important; */
      padding: 0;
      margin-right: 11px;
      text-align: left;
        color: #424242
}
.bbsdialog .formCon .el-upload{
  width: 369px;
  height: 90px;
   background: #F2F2F2;
   border: none;
       display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.bbsdialog .formCon .el-upload .upText{
  font-size: 14px;
  color: #424242;
  line-height: normal;
}
.bbsdialog .formCon .uploadImg{
  display: flex
}
.bbsdialog .formCon .uploadImg .el-upload-list{
    width: 405px;
  height: 90px;
  margin-right: 11px;
  position: absolute
}
.bbsdialog .formCon .formBtn{
    width: 100px;
    height: 40px;
    color: #ffffff;
    border: none;
    font-size: 18px
}
.bbsdialog .formCon .formBtn:nth-last-child(1){
    background: #CCCCCC
}
.bbsdialog .formCon .dialog-footer{
    text-align: center
}
.bbsdialog .formCon .formBtn:nth-last-child(2){
    background: #FF9E00
}
.bbsdialog .formCon .uploadImg .el-upload-list__item-actions,
.bbsdialog .formCon .uploadImg li{
  width: 369px;
  height: 90px;
  z-index: 3;
}
/* 去除图片反显动画 */
.el-upload-list__item{
      transition: none !important;
    }
</style>